export default {
  //* loadConfig ---------------------------------------------------------------------------------------------------------------

  async loadConfig({ rootGetters, commit }) {
    // load quotes from backend
    var resp_json = "",
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok; // composition of the token
    const response = await fetch(base_address + "/getConfigs", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
    }).catch((e) => console.log(e));
    if (response.ok) {
      resp_json = await response.json();
      commit("setConfigs", resp_json);
      localStorage.setItem("configs", JSON.stringify(resp_json));
    }
  },

  //* loadConfirm ---------------------------------------------------------------------------------------------------------------

  async loadConfirm({ rootGetters }, camping) {
    // load quotes from backend
    var resp_json = "",
      base_address = rootGetters["settings/getBaseAddress"];
    const response = await fetch(base_address + "/getConfirms", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: JSON.stringify({ camp: camping }),
    }).catch((e) => console.log(e));
    if (response.ok) {
      resp_json = await response.json();
    }
    return resp_json;
  },

  //* addConfig ---------------------------------------------------------------------------------------------------------------

  async addConfig({ rootGetters }, payload) {
    // @payload needs the quotes infos needed
    /**
		 *! Payload form:
		 *
		 *
		 * {
		 * 	 group:{ // like preventivo or client etc...
                type: String
            },

            option:{
                type: Object, // JSON obj
                default: []
            },
		 * }
		 */
    var ret_val = 400,
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token
    var resp = await fetch(base_address + "/addConfig", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: JSON.stringify(payload),
    });
    if (resp.ok) {
      ret_val = 200;
    }
    return ret_val;
  },

  //* addCamping ---------------------------------------------------------------------------------------------------------------

  async addCamping({ rootGetters }, payload) {
    // @payload needs the quotes infos needed
    /**
		 *! Payload form:
		 *
		 *
		 * {
		 * 	 name:{ // like preventivo or client etc...
                type: String
            },

            max_users:{
                type: Number, // JSON obj
                default: 1
            },
		 * }
		 */
    var ret_val = 400,
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token
    var resp = await fetch(base_address + "/addCamping", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: JSON.stringify(payload),
    });
    if (resp.ok) {
      ret_val = 200;
    }
    return ret_val;
  },

  //* deleteConfig ---------------------------------------------------------------------------------------------------------------

  async deleteConfig({ rootGetters }, id) {
    // @payload needs the config id
    var ret_val = 400,
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token
    await fetch(base_address + "/deleteOption/" + id, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
    }).then((response) => {
      if (response.ok) {
        ret_val = 200; // means ok, all right (http protocol)
      }
    });
    return ret_val;
  },

  //* patchCamping ---------------------------------------------------------------------------------------------------------------

  // update backend side
  async patchCamping({ rootGetters }, payload) {
    // @payload needs the id of the quotes and all the attributes needed
    /*
			! ATTENTION:
			control the data being patched otherwise the patch oper. is not permitted
		*/
    const idCamping = payload._id;
    // otherwise the patch is not permitted
    delete payload._id;
    delete payload.MonthlyEmailSent;
    delete payload.__v;
    delete payload.date_creation;
    var ret_val = 400,
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"],
      data = JSON.stringify(payload);
    tok = "Bearer " + tok; // composition of the token
    var response = await fetch(base_address + "/editCamping/" + idCamping, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: data,
    });
    if (response.ok) {
      ret_val = 200; // means ok, all right (http protocol)
    }
    return ret_val;
  },

  //* deleteCamping ---------------------------------------------------------------------------------------------------------------

  async deleteCamping({ rootGetters }, id) {
    // @payload needs the config id
    var ret_val = 400,
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token
    // console.log('deleteCamping')
    await fetch(base_address + "/deleteCamping/" + id, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
    }).then((response) => {
      if (response.ok) {
        ret_val = 200; // means ok, all right (http protocol)
      }
    });
    return ret_val;
  },

  //* patchUser ---------------------------------------------------------------------------------------------------------------

  // update backend side
  async patchUser({ rootGetters }, payload) {
    // @payload needs the id of the quotes and all the attributes needed
    /*
			! ATTENTION:
			control the data being patched otherwise the patch oper. is not permitted
		*/
    const idUser = payload._id;
    // otherwise the patch is not permitted
    delete payload._id;
    delete payload.camping;
    delete payload.lastLogin;
    delete payload.loginArray;
    delete payload.__v;
    delete payload.password;
    var ret_val = 400,
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"],
      data = JSON.stringify(payload);
    tok = "Bearer " + tok; // composition of the token
    var response = await fetch(base_address + "/editUser/" + idUser, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: data,
    }).catch((e) => console.log(e));
    if (response.ok) {
      ret_val = 200; // means ok, all right (http protocol)
    }
    return ret_val;
  },

  //* updatePassword ---------------------------------------------------------------------------------------------------------------

  async updatePassword({ rootGetters }, payload) {
    // @payload needs the id of the quotes and all the attributes needed
    /*
			! ATTENTION:
			control the data being patched otherwise the patch oper. is not permitted
		*/
    const idUser = payload.userID;
    // otherwise the patch is not permitted
    var ret_val = 400,
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"],
      data = JSON.stringify(payload);
    tok = "Bearer " + tok; // composition of the token
    var response = await fetch(base_address + "/editPassword/" + idUser, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: data,
    }).catch((e) => console.log(e));
    if (response.ok) {
      ret_val = 200; // means ok, all right (http protocol)
    }
    return ret_val;
  },

  //* deleteUser ---------------------------------------------------------------------------------------------------------------

  async deleteUser({ rootGetters }, id) {
    // @payload needs the config id
    var ret_val = 400,
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token
    await fetch(base_address + "/deleteUser/" + id, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
    }).then((response) => {
      if (response.ok) {
        ret_val = 200; // means ok, all right (http protocol)
      }
    });
    return ret_val;
  },

  //* patchConfig ---------------------------------------------------------------------------------------------------------------

  async patchConfig({ rootGetters }, payload) {
    // @payload needs the id of the quotes and all the attributes needed
    /*
			! ATTENTION:
			control the data being patched otherwise the patch oper. is not permitted
		*/
    const body = {};
    const idConfig = payload._id;
    body.group = payload.group;
    body.option = payload.option;
    var ret_val = 400,
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"],
      data = JSON.stringify(body);
    tok = "Bearer " + tok; // composition of the token
    var response = await fetch(base_address + "/editConfig/" + idConfig, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: data,
    }).catch((e) => console.log(e));
    if (response.ok) {
      ret_val = 200; // means ok, all right (http protocol)
    }
    return ret_val;
  },

  //* bindGmail ---------------------------------------------------------------------------------------------------------------

  // update backend side
  async bindGmail({ rootGetters }, payload) {
    // @payload needs the id of the quotes and all the attributes needed
    /*
			! ATTENTION:
			control the data being patched otherwise the patch oper. is not permitted
		*/
    // otherwise the patch is not permitted
    var ret_val = 400,
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"],
      data = JSON.stringify(payload);
    tok = "Bearer " + tok; // composition of the token
    var response = await fetch(base_address + "/bindGmail", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: data,
    });
    if (response.ok) {
      ret_val = 200; // means ok, all right (http protocol)
    }
    return ret_val;
  },

  //* getMinisito ---------------------------------------------------------------------------------------------------------------

  async getMinisito({ rootGetters }, payload) {
    // @payload needs the id of the quotes and all the attributes needed
    const idCamping = payload.idCamping;
    var tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok; // composition of the token
    var response = await fetch(base_address + "/getMinisito/" + idCamping, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: JSON.stringify({ idMinisito: payload.idMinisito })
    }).catch((e) => console.log(e));
    if (response.ok) {
      response = await response.json(); // means ok, all right (http protocol)
    } else {
      response = {};
    }
    return response;
  },

  //* queryConfigCamp ---------------------------------------------------------------------------------------------------------------

  async queryConfigCamp({ rootGetters }, data) {
    // load quotes from backend
    var base_address = rootGetters["settings/getBaseAddress"];
    var response = await fetch(base_address + "/queryConfigCamp", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: JSON.stringify(data),
    }).catch((e) => console.log(e));
    response = await response.json();
    return response;
  },

  //* queryConfig ---------------------------------------------------------------------------------------------------------------

  async queryConfig({ rootGetters }, data) {
    // load quotes from backend
    var tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok; // composition of the token
    var response = await fetch(base_address + "/queryConfig", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: JSON.stringify(data),
    }).catch((e) => console.log(e));
    response = await response.json();
    // console.log(response);
    return response;
  },

  //* queryConfigNoAuth ---------------------------------------------------------------------------------------------------------------

  async queryConfigNoAuth({ rootGetters }, data) {
    // load quotes from backend
    var tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok; // composition of the token
    var response = await fetch(base_address + "/queryConfigNoAuth", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: JSON.stringify(data),
    }).catch((e) => console.log(e));
    response = await response.json();
    return response;
  },

  //* loadCampingUrl ---------------------------------------------------------------------------------------------------------------

  async loadCampingUrl({ rootGetters, commit }) {
    // load quotes from backend
    var resp_json = "",
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"],
      usr = rootGetters["auth/getUser"];
    if (!(usr instanceof Object)) {
      usr = JSON.parse(usr);
    }
    var idCamping = usr.camping;
    tok = "Bearer " + tok; // composition of the token
    const response = await fetch(base_address + "/getCamping/" + idCamping, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
    }).catch((e) => console.log(e));
    if (response.ok) {
      resp_json = await response.json();
      commit("setCamping", resp_json);
      var url = resp_json.urlToCV;
      if (!url) {
        url = "NON DEFINITO";
      }
      commit("setUrlToCV", url);
    }
  },

  //* CVSynch ---------------------------------------------------------------------------------------------------------------

  async CVSynch({ rootGetters }, payload) {
    // load quotes from backend
    var resp_json = "",
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok; // composition of the token

    var opts = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
    };

    if(payload){
      opts.body = JSON.stringify(payload)
    }

    const response = await fetch(base_address + "/cv/api/utentiData", opts).catch((e) => console.log(e));
    if (response.ok) {
      resp_json = await response.json();
    }
    return resp_json;
  },
};
